import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const PortalCtx = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const portalApi = axios.create({ baseURL: API, withCredentials: true });

export const PortalProvider = ({ children }) => {
  const [client, setClient] = useState(undefined);
  useEffect(() => {
    // Only probe portal identity when we're actually on a portal page
    const isPortal = typeof window !== "undefined" && window.location.pathname.startsWith("/portal");
    if (!isPortal) { setClient(null); return; }
    portalApi.get("/portal/me").then((r) => setClient(r.data)).catch(() => setClient(null));
  }, []);
  const logout = async () => {
    try { await portalApi.post("/portal/logout"); } catch {}
    setClient(null);
  };
  const setPortalClient = (c) => setClient(c);
  return <PortalCtx.Provider value={{ client, setPortalClient, logout }}>{children}</PortalCtx.Provider>;
};
export const usePortal = () => useContext(PortalCtx);
